import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavedGroceryFromInstacartCartInput } from '@/models/grocery';

export const createSavedGroceryFromInstacartCart = async ({
  cartId,
  callerPhoneNumber,
  instacartEmailAddress,
  preferredCartName,
  notes,
}: SavedGroceryFromInstacartCartInput): Promise<string> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateSavedGroceryFromInstacartCart(
        $cartId: String!
        $callerPhoneNumber: String!
        $instacartEmailAddress: String!
        $notes: String
        $preferredCartName: String
      ) {
        createSavedGroceryFromInstacartCart(
          cartId: $cartId
          callerPhoneNumber: $callerPhoneNumber
          instacartEmailAddress: $instacartEmailAddress
          notes: $notes
          preferredCartName: $preferredCartName
        )
      }
    `),
    variables: {
      cartId,
      callerPhoneNumber,
      instacartEmailAddress,
      preferredCartName,
      notes,
    },
  });

  return response.data?.createSavedGroceryFromInstacartCart ?? '';
};
